import React from "react";
import Projects from "../Projects/Projects";

const Home = () => {
  document.title = "Pagina Inicial";
  return <Projects />;
};

export default Home;
